import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

import {
  updateTournament,
} from "../../redux/slices/tournamentSlice";
import ClubbieButton from "../ClubbieButton/ClubbieButton";
import ClubbieModal from "../Modal/ClubbieModal";
import { fixedValues } from "../../utils/fixedValues";

/**
 * UpdateTournamentType - JSX component with Tailwind CSS
 * Modal for updating tournament type (LEAGUE, CUP, GROUP, KNOCKOUT)
 * 
 * Features:
 * - Radio-like button selector for tournament types
 * - Visual feedback for selected type
 * - Updates tournament type via Redux
 * - Toast notifications
 * 
 * @param {boolean} isOpen - Modal visibility state
 * @param {function} onClose - Callback to close modal
 */
const UpdateTournamentType = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const selectedTournament = useSelector(
    (state) => state.tournament.selectedTournament
  );
  const [selectedType, setSelectedType] = useState(
    selectedTournament?.type || ""
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleUpdateType = async () => {
    try {
      if (!selectedType) {
        toast.error("Please select a tournament type");
        return;
      }

      setIsLoading(true);
      let updateData = { type: selectedType };

      // First update the tournament type
      await dispatch(
        updateTournament({
          id: selectedTournament?.id,
          updateData,
        })
      ).unwrap();

      // if (selectedType !== fixedValues.tournamentTypes.LEAGUE) {
      //   // Create a new division with default season
      //   const divisionData = {
      //     name: fixedValues.defaultTournamentDetails.division.name,
      //     seasons: [
      //       {
      //         name: fixedValues.defaultTournamentDetails.division.season.name,
      //         teams: [],
      //         referees: [],
      //       },
      //     ],
      //   };

      //   const result = await dispatch(
      //     createDivision({
      //       tournamentId: selectedTournament?.id,
      //       divisionData,
      //     })
      //   ).unwrap();

      //   if (result) {
      //     // Select the newly created division and its first season
      //     const newDivision = result.divisions[result.divisions.length - 1];
      //     if (newDivision) {
      //       dispatch(selectDivision(newDivision));
      //       const defaultSeason = newDivision.season[0];
      //       if (defaultSeason) {
      //         dispatch(selectSeason(defaultSeason));
      //       }
      //     }
      //   }
      // } else {
      //   // For LEAGUE type, clear selections if current division is the default one
      //   const currentDivision = selectedTournament?.divisions?.find(
      //     (division) =>
      //       division.name === fixedValues.defaultTournamentDetails.division.name
      //   );
      //   if (currentDivision) {
      //     dispatch(selectDivision(null));
      //     dispatch(selectSeason(null));
      //   }
      // }

      toast.success("Competition type updated successfully!");
      onClose();
    } catch (error) {
      toast.error(error.message || "Failed to update competition type");
    } finally {
      setIsLoading(false);
    }
  };

  const tournaments = [
    {
      id: fixedValues.tournamentTypes.LEAGUE,
      name: fixedValues.tournamentTypes.LEAGUE,
    },
    {
      id: fixedValues.tournamentTypes.CUP,
      name: fixedValues.tournamentTypes.CUP,
    },
    {
      id: fixedValues.tournamentTypes.GROUP,
      name: fixedValues.tournamentTypes.GROUP,
    },
    {
      id: fixedValues.tournamentTypes.KNOCKOUT,
      name: fixedValues.tournamentTypes.KNOCKOUT,
    },
  ];

  return (
    <ClubbieModal
      isOpen={isOpen}
      toggle={onClose}
      title="Update Competition Type"
    >
      <div className="flex flex-col gap-4 p-6">
        {tournaments.map((tournament) => (
          <button
            key={tournament.id}
            className={`flex items-center gap-3 p-4 rounded-lg border transition-all ${
              selectedType === tournament.id
                ? "border-[#00D1FF] bg-[#00D1FF]/10"
                : "border-[#2A3F54] bg-[#000F1F] hover:border-[#00D1FF]/50"
            }`}
            onClick={() => setSelectedType(tournament.id)}
            type="button"
          >
            <div
              className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                selectedType === tournament.id
                  ? "border-[#00D1FF]"
                  : "border-[#2A3F54]"
              }`}
            >
              {selectedType === tournament.id && (
                <div className="w-3 h-3 rounded-full bg-[#00D1FF]" />
              )}
            </div>
            <span className="text-[#FEFCEB] text-base font-medium">
              {tournament.name}
            </span>
          </button>
        ))}

        <ClubbieButton
          className="w-full mt-2"
          onClick={handleUpdateType}
          disabled={isLoading || !selectedType}
          isLoading={isLoading}
        >
          Update
        </ClubbieButton>
      </div>
    </ClubbieModal>
  );
};

export default UpdateTournamentType;
